export class Branches {
    ID:number;
CLIENT_ID:number;
NAME:string;
MANAGER_NAME:string;
POST:string;
ADDRESS:string;
PHONE_NO:string;
SEQUENCE_NO:number;
}